import React from "react";
import { CheckCircle, Award, Recycle, PhoneCall } from "lucide-react";
import { advantages } from "@/data/metiers/garagisteData";

const iconMap = {
  CheckCircle,
  Award,
  Recycle,
  PhoneCall
};

const GaragisteAdvantages = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-fabre-lightgray to-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-heading font-bold mb-6 text-fabre-gray">
              Pourquoi choisir Groupe Fabre pour votre garage ?
            </h2>
            <div className="w-24 h-1.5 bg-gradient-to-r from-fabre-green to-fabre-teal mx-auto mb-8 rounded-full"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {advantages.map((advantage, index) => {
              const IconComponent = iconMap[advantage.icon as keyof typeof iconMap];
              
              return (
                <div key={index} className="bg-white rounded-2xl shadow-lg p-8 hover:shadow-xl transition-all duration-300 border border-gray-100">
                  <div className="flex items-start">
                    <div className="bg-gradient-to-br from-fabre-lightgreen to-fabre-green/20 p-3 rounded-xl mr-4 flex-shrink-0">
                      <IconComponent className="h-6 w-6 text-fabre-green" />
                    </div>
                    <div>
                      <h3 className="text-xl font-heading font-bold mb-3 text-fabre-gray">
                        {advantage.title}
                      </h3>
                      <p className="text-gray-700 leading-relaxed">
                        {advantage.description}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default GaragisteAdvantages;